import { getCookie } from "./cookies";
import {
  type TConsentState,
  ZConsentState,
} from "../contexts/CookieConsentContext";

export const getStoredCookieConsent = (): TConsentState => {
  const consent = getCookie("cookie-consent");

  if (!consent) {
    return { functional: true, analytics: false, chosen: false };
  }

  try {
    return ZConsentState.parse(JSON.parse(consent));
  } catch {
    return { functional: true, analytics: false, chosen: false };
  }
};
